export default {
  name: "FilePreviewComponent",
  props: {
    presigned_url: {
      type: String,
      default: "",
    },
    file_name: {
      type: String,
      default: "",
    },
    shared_access_level: {
      type: Object,
      default: null,
    },
  },
  emits: ["close", "open-office-file"],
  computed: {
    preview_url() {
      return this.presigned_url || "";
    },

    internal_file_name() {
      return this.file_name || "";
    },

    file_type() {
      const name_parts = this.internal_file_name.split(".");
      return name_parts.length > 1
        ? name_parts[name_parts.length - 1].toLowerCase()
        : "";
    },

    can_download() {
      if (!this.shared_access_level) {
        return true;
      }

      return this.shared_access_level.name !== "Viewer";
    },

    is_office_file() {
      return [
        "doc",
        "docx",
        "xls",
        "xlsx",
        "xlsm",
        "xlsb",
        "ppt",
        "pptx",
        "odt",
        "ods",
        "odp",
        "csv",
      ].includes(this.file_type);
    },

    can_use_office_web_preview() {
      return [
        "doc",
        "docx",
        "xls",
        "xlsx",
        "xlsm",
        "ppt",
        "pptx",
      ].includes(this.file_type);
    },

    absolute_preview_url() {
      if (!this.preview_url) return "";
      try {
        return new URL(this.preview_url, window.location.origin).href;
      } catch {
        return "";
      }
    },

    office_preview_url() {
      if (!this.can_use_office_web_preview || !this.absolute_preview_url) {
        return "";
      }

      return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(this.absolute_preview_url)}`;
    },
  },
  methods: {
    close_file_preview_modal() {
      this.$emit("close");
    },
  },
};
